@if ('select' === field.type) {
  <ng-container [formGroup]="form">
    <ng-container *ngTemplateOutlet="InputTemplate" [formGroupName]="field.group ? field.group : null" ></ng-container>
  </ng-container>
} @else {
  <div class="form-group mb-3">
    {{ field.control }} verkeerde input type: {{ field.type }} ipv select
  </div>
}

<ng-template #InputTemplate>
  <div class="form-group mb-3" [ngClass]="{'d-flex align-items-center': inlineLabel }">
    <label [for]="field.control" class="text-bold">{{ field.label | translate }}</label>

    <select class="form-control"
      [id]="field.control"
      [formControl]="Control"
      (ngModelChange)="selectOption($event)">
      @if (!isRequired) {
        <option [ngValue]="null">{{ 'form.select_option' | translate }}</option>
      }
      @for (option of field.options; track option) {
        <option [value]="option.value">{{ option.label | translate }}</option>
      }
    </select>
  </div>
</ng-template>

